import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { ActionType } from '@src/types/action';
import ButtonClaims from './../../claims/button';
import {
  FunctionComponent,
  useEffect,
  useRef,
  useState,
  useContext,
} from 'react';
import ConnectServicesClient from '@shared/clients/ConnectServiceClient';
import ClaimTrackerClient from '@shared/clients/ClaimsTrackerClient';
import DocumentTemplatesClient from '@shared/clients/DocumentTemplatesClient';
import { IInspectionContext, InspectionContext } from '@context/inspections';

// Configure dayjs
dayjs.extend(localizedFormat);
dayjs.locale('es');

interface ClaimStepsProps {
  claim: any;
  uId: string;
}
interface Fields {
  key: string;
  value: string;
}

const SendDocument: FunctionComponent<ClaimStepsProps> = ({
  claim,
  uId,
}): JSX.Element => {
  const { dispatch } = useContext<IInspectionContext>(InspectionContext);
  const effectRan = useRef(false);
  const [documents, setDocuments] = useState<any>([]);
  const [template, setTemplate] = useState<any>(null);
  const [subject, setSubject] = useState(null);
  const [message, setMessage] = useState(null);
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    if (effectRan.current === false) {
      dispatch({ type: ActionType.SET_LOADING, payload: true });

      const getDataInitial = async () => {
        const docs = await new DocumentTemplatesClient().getAllTemplates();
        setDocuments(docs);
      };

      getDataInitial();

      dispatch({ type: ActionType.SET_LOADING, payload: false });
      effectRan.current = true;
    }
  }, []);
  useEffect(() => {
    setDisabled(!(template && subject && message));
  }, [template, subject, message]);
  const changeTemplate = (event) => {
    setTemplate(event?.target.value);
  };

  const changeSubject = (event) => {
    setSubject(event?.target.value);
  };
  const changeMessage = (event) => {
    setMessage(event?.target.value);
  };

  const handleSendMail = async () => {
    dispatch({ type: ActionType.SET_LOADING, payload: true });
    const vari = await new ConnectServicesClient().getVariablesTemplate(
      '6',
      template,
    );
    const varAll = await new DocumentTemplatesClient().getVariables(template);
    const result = extractData(vari, varAll);
    const pdf = await new DocumentTemplatesClient().generatePDF({
      id: template,
      parameters: result,
    });
    await new ClaimTrackerClient().sendDocumentTemplate({
      id: uId,
      subject: subject,
      message: message,
      pdf: pdf,
    });

    dispatch({ type: ActionType.SET_LOADING, payload: false });
  };

  const extractFieldsFromClaim = (claim: any): Fields[] => {
    const fields: Fields[] = [];

    const processField = (field: any) => {
      const existingField = fields.find((x) => x.key === field.keyName);
      if (existingField?.value !== field.defaultValue) {
        if (existingField) {
          existingField.value = field.defaultValue;
        } else {
          fields.push({ key: field.keyName, value: field.defaultValue });
        }
      }
    };

    try {
      claim.steps
        ?.filter((step) => step.sections)
        ?.forEach((step) => {
          step.sections
            ?.filter((section) => section.containers?.[0]?.fields)
            ?.forEach((section) => {
              section.containers[0].fields.forEach(processField);
            });
        });

      return fields;
    } catch (error) {
      console.error('Error al procesar los campos:', error);
      throw new Error('Error al extraer los campos del reclamo');
    }
  };

  const extractData = (variables, valAll) => {
    const result = {};
    const fields = extractFieldsFromClaim(claim);
    valAll.forEach(function (v) {
      if (v.startsWith('currentDate')) {
        const date = dayjs().format(
          v.startsWith('currentDate(')
            ? v.replace('currentDate(', '').replace(')', '')
            : 'MM/DD/YYYY',
        );
        result[v] = date;
      } else {
        const v1 = variables.data.find((x) => x.variable === v);
        if (v1 !== null) {
          const props = v1.fieldId.split('.');
          const inte = props[0] === 'FORM[]' ? false : true;
          if (inte) {
            let valu = claim.info;
            props.forEach(function (item) {
              valu = valu[item];
              if (v.toLowerCase().includes('fecha')) {
                const valu2 = valu.split('-');
                valu = `${valu2[1]}/${valu2[2]}/${valu2[0]}`;
              }
            });
            result[v] = valu;
          } else {
            const field = fields.find((x) => x.key === props[1]);
            if (field !== undefined) {
              if (v.toLowerCase().includes('fecha')) {
                const valu2 = field?.value.split('-');
                if (valu2?.length == 3) {
                  field.value = `${valu2[1]}/${valu2[2]}/${valu2[0]}`;
                }
              }
              result[v] = field?.value;
            }
          }
        }
      }
    });

    return result;
  };

  return (
    <Box sx={{ paddingTop: '1rem' }}>
      <label>Enviar documento</label>
      <br />
      <br />
      <Grid container spacing={2} className="sendDocument">
        <Grid item xs={3}>
          <FormControl sx={{ minWidth: 320 }}>
            <InputLabel>Seleccione plantilla</InputLabel>
            <Select
              label="Seleccione plantilla"
              value={template}
              autoWidth
              onChange={changeTemplate}
            >
              {documents.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={9}>
          <TextField
            label="Asunto"
            value={subject}
            style={{ width: '90%' }}
            onChange={changeSubject}
          />
          <br />
          <br />
          <TextField
            style={{ width: '90%' }}
            label="Mensaje"
            multiline
            rows={4}
            value={message}
            onChange={changeMessage}
          />
          <br />
          <br />
          <ButtonClaims
            disabled={disabled}
            style={{ position: 'relative', float: 'right', marginRight: '10%' }}
            onClick={handleSendMail}
            text="Enviar documento"
          />
          <br />
          <br />
          <br />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SendDocument;
